import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useNetworkStatus } from '../hooks/useMobile';

const OfflineIndicator = () => {
  const { isOffline } = useNetworkStatus();

  // Only show when offline
  if (!isOffline) {
    return null;
  }

  return (
    <div className="bg-red-600 text-white px-4 py-2 text-sm transition-all duration-300">
      <div className="flex items-center justify-center max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          <ExclamationTriangleIcon className="w-4 h-4" />
          <span>You're currently offline</span>
        </div>
      </div>
    </div>
  );
};

export default OfflineIndicator;
